import React from 'react';
import { Link } from 'react-static';
import styled from 'styled-components';
import { withSiteData } from 'react-static';
import { AuxNavigation, SocialMediaNavigation } from '@flow/components/navigation';
import em from 'polished/lib/helpers/em';
import NewsletterForm from '@flow/components/newsletter/NewsletterForm';
import { IOptions } from 'types/IOptions';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

const LeftColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 10em;
`;

const Column = styled.div`
  &:first-child {
    margin-right: 8.8em;
  }

  p {
    font-family: Flow-Poster-Bold;
    display: block;
    font-size: 2.8em;
    line-height: ${em(4.8, 2.8)};
    white-space: nowrap;
    
    @media (max-width: 900px) {
      font-size: ${28 / (900 * 0.01)}vw;
    }
  
    @media (max-width: 640px) {
      font-size: 2em;
    }
  }
`;

const ContactWrapper = styled.div`
  display: flex;
  margin-top: 6.6em;
`;

const Links = styled.div`
  margin-right: ${em(4, 1.8)};
`;

const LinkBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  font-size: 1.8em;
  padding-left: ${em(3, 1.8)};
  padding-right: ${em(3, 1.8)};
  border-top: ${em(0.1, 1.8)} solid ${props => props.theme.highlightColor};
  
  > div {
    padding-top: ${em(3, 1.8)};
    padding-bottom: ${em(3, 1.8)};
    
  }
  
  a {
    margin-right: ${em(1.5, 1.8)};
    
    span {
      padding-right: ${em(1.5, 1.8)};  
    }
    
    &:after {
      content: '/';
      display: inline-block;
    }
    
    &:last-of-type {
      margin-right: 0;
      
      &:after {
        display: none;
      }
      
      span {
        padding-right: 0;
      }
    }
    
    &:${props => props.theme.hoverProperty} {
      span {
        color: ${props => props.theme.highlightColor};
      }
    }  
  }
  
  @media only screen and (max-width: 600px) {
    align-items: flex-start;
    a {
      display: block;
      padding: 1em 0;
      
      &:first-child {
        padding-top: 0;
      }
      
      &:after {
        display: none;
      }
    }
  }
`;

const Wrapper = styled.footer`
  display: flex;
  justify-content: space-between;
  padding: 6em 3em;
  
  @media only screen and (max-width: 1200px) {
    flex-direction: column-reverse;
    
    ${LeftColumnWrapper} {
      margin-top: 8em;
    }
  }
  
  @media only screen and (max-width: 800px) {
    ${Column}:first-child {
      margin-right: 4.4em;
    }
  }
  
  @media only screen and (max-width: 750px) {
    ${Column} {
      padding-top: 2em;
      &:first-child {
        margin-right: 0;
        padding-top: 0;
      }
    }
    
    ${ContactWrapper} {
      flex-direction: column;     
    }
  }
`;

interface Props {
  appLanguage: IAppLanguage;
  options: IOptions;
}

const Footer = ({
  appLanguage,
  options,
}: Props) => {

  const {
    footer_contact,
    newsletter_group,
    aux_navigation,
    flow_hashtag,
  } = appLanguage ? options[appLanguage.code] : options.fi;

  return (
    <div>
      <Wrapper>
        <LeftColumnWrapper>
          <AuxNavigation aux_navigation={aux_navigation} />
          <SocialMediaNavigation flow_hashtag={flow_hashtag} />
        </LeftColumnWrapper>

        <div>
          <NewsletterForm newsletter_group={newsletter_group} langCode={appLanguage.code}/>

          <ContactWrapper>
            <Column dangerouslySetInnerHTML={{ __html: footer_contact.left_column }} />
            <Column dangerouslySetInnerHTML={{ __html: footer_contact.right_column }} />
          </ContactWrapper>
        </div>
      </Wrapper>
      <LinkBar>
        <Links>
          <Link to={appLanguage.path + (appLanguage.code === 'fi' ? 'tietosuojaseloste' : 'privacypolicy')}>
            <FormattedMessage id={'privacyPolicyLinkLabel'}/>
          </Link>
          <Link to={appLanguage.path + 'cookies-policy'}><FormattedMessage id={'cookiePolicyLinkLabel'}/></Link>
        </Links>
        <div>
          <FormattedMessage id={'rightsReserved'} />
        </div>
      </LinkBar>
    </div>
  )
};

const mapStateToProps = ({ navigationReducer }: any) => {
  const {
    appLanguage,
    lang_versions,
  } = navigationReducer;

  return {
    appLanguage,
    lang_versions
  }
};

export default connect(
  mapStateToProps
)(withSiteData(Footer));


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/footer/Footer.tsx